import { Table } from "react-bootstrap";
import useQueryFetch from "../../../../../hooks/useQueryFetch";
import request from "../../../../../utils/request";

const VaccineTable = ({ user }) => {
  const { data: vaccineTests } = useQueryFetch(
    ["vaccineTests", user?.id],
    () => request.getOne("reports/vaccine/reports", user?.id),
    {
      placeholderData: [],
    }
  );

  return (
    <tr>
      <td
        colSpan={2}
        className="text-nowrap text-uppercase fw-bold text-center border border-dark p-0 border-end-0"
      >
        <div className="d-flex ">
          <div className="px-3 border-end border-dark m-0 d-flex align-items-center justify-content-center">
            <p className="m-0">Vaccine</p>
          </div>
          <InvestigationTable2 investigations={vaccineTests} />
        </div>
      </td>
      {/* <td className="p-0 ">
        <InvestigationTable2 investigations={vaccineTests} />
      </td> */}
    </tr>
  );
};
export default VaccineTable;

function InvestigationTable2({ investigations }) {
  // Pair items two-by-two
  const pairs = [];
  for (let i = 0; i < investigations?.length; i += 2) {
    pairs.push([investigations[i], investigations[i + 1]]);
  }

  return (
    <table className="w-100 m-0 border-dark">
      <tbody>
        {pairs.map(([left, right], i) => (
          <tr key={i}>
            {left && (
              <>
                <td
                  className={`border-end  ${
                    i % 2 === 0 ? "border-bottom" : ""
                  } border-dark w-25 ps-1`}
                >
                  {left.name.toUpperCase()}
                </td>
                <td
                  className={`border-end  ${
                    i % 2 === 0 ? "border-bottom" : ""
                  } border-dark ps-1`}
                >
                  {left.result}
                </td>
              </>
            )}
            {right ? (
              <>
                <td
                  className={`border-end  ${
                    i % 2 === 0 ? "border-bottom" : ""
                  } border-dark w-25 ps-1`}
                >
                  {right.name.toUpperCase()}
                </td>
                <td
                  className={`border-end  ${
                    i % 2 === 0 ? "border-bottom" : ""
                  } border-dark ps-1`}
                >
                  {right.result}
                </td>
              </>
            ) : (
              <>
                <td className="w-25 ps-1"></td>
                <td className="ps-1"></td>
              </>
            )}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
